import React from "react";

function Portfolio() {
  return <div>Hello Portfolio</div>;
}

export default Portfolio;
